/* eslint-disable react/jsx-newline */
import { useTranslation } from 'react-i18next';
import {
  Grid,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';
import Head from 'next/head';

import { footerImageOffset } from 'components/Footer/styles';
import { Header } from 'components/Header';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import * as S from './styles';

const PrivacyPolicy: React.FC = () => {
  const { t, ready } = useTranslation();
  const { greaterThan } = useViewport();

  return (
    <>
      <Head>
        <title key="title">Privacy policy | Lami </title>

        <meta
          key="description"
          name="description"
          content="Privacy policy Lami. Prenota in pochi click una video visita o una visita domiciliare con i nostri specialisti comodamente da casa tua."
        />
      </Head>

      <Header />

      <SectionWrapper
        paddingTop="none"
        paddingBottom={greaterThan('tablet') ? 'xxlarge' : 'xlarge'}
        additionalPadding={footerImageOffset}
      >
        <S.Wrapper>
          <Grid.Wrapper>
            <Typography
              variant="heading_1"
              color="text__highlight"
              as="h1"
              textAlign="center"
            >
              {t('page--privacy-policy.privacyPolicyTitle')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.privacyPolicyDescription1')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.privacyPolicyDescription2')}
            </Typography>

            <Typography marginBottom="none">
              {t('page--privacy-policy.privacyPolicyDescription3')}
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.controllerTitle')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.controllerDescription')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.controllerContact')}
            </Typography>

            <Typography marginBottom="none">
              {t('page--privacy-policy.dpoInfo')}
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.processingSubjectTitle')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.processingSubjectDescription')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.specialCategoriesInfo')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.minorsProcessingInfo')}
            </Typography>

            <Typography marginBottom="none">
              {t('page--privacy-policy.symptomCheckerInfo')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.dataProcessedTitle')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.dataProcessedDescription1')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.dataProcessedDescription2')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.dataProcessedDescription3')}
            </Typography>

            <Typography marginBottom="none">
              {t('page--privacy-policy.dataProcessedDescription4')}
            </Typography>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.dataPurposeTitle')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.dataPurposeIntroduction')}
            </Typography>

            <S.List>
              <S.Item>{t('page--privacy-policy.dataPurposeItem1')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem2')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem3')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem4')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem5')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem6')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem7')}</S.Item>
              <S.Item>{t('page--privacy-policy.dataPurposeItem8')}</S.Item>
            </S.List>
            <Typography>
              {t('page--privacy-policy.symptomCheckerToolUsage')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.symptomCheckerDataHandling')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.pseudoAnonymizedDataUsage')}
            </Typography>

            <Typography>
              {t('page--privacy-policy.dataUsageConclusion')}
            </Typography>

            <S.TableWrapper>
              <table>
                <thead>
                  <tr>
                    <th>{t('page--privacy-policy.tableHeaderPurpose')}</th>
                    <th>
                      {t('page--privacy-policy.tableHeaderDataCategories')}
                    </th>
                    <th>{t('page--privacy-policy.tableHeaderLegalBasis')}</th>
                  </tr>
                </thead>
                <tbody>
                  {ready &&
                    t('page--privacy-policy.dataUsageTable', {
                      returnObjects: true,
                    }).map((row, index) => (
                      <tr key={index}>
                        <td>{row.purpose}</td>
                        <td>{row.dataCategories}</td>
                        <td>{row.legalBasis}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </S.TableWrapper>

            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.treatmentMethodTitle')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.treatmentMethodDescription')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.storageDataDescription')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.symptomCheckerDescription')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.categoriesOfSubjectsTitle')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataProvidedDescription')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.informationHealthDescription')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataPersonalCollectionsDescription')}
            </Typography>

            <S.List>
              <S.Item>{t('page--privacy-policy.doctorsPerformance')}</S.Item>
              <S.Item>{t('page--privacy-policy.mandatoryEntities')}</S.Item>
              <S.Item>{t('page--privacy-policy.healthFacilities')}</S.Item>
              <S.Item>{t('page--privacy-policy.insuranceFunds')}</S.Item>
              <S.Item>{t('page--privacy-policy.analysisLaboratory')}</S.Item>
              <S.Item>
                {t('page--privacy-policy.attendingDoctorUrgency')}
              </S.Item>
            </S.List>
            <Typography>
              {t('page--privacy-policy.internalAndExternalStaffAccess')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.youCanContactTheOwnerAtAnyTime')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.dataCommunicationRequirement')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.consentCollection')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.consentAcquisitionMethods')}
            </Typography>

            <S.List>
              <S.Item>
                {t('page--privacy-policy.consentRequestedDirectly')}
              </S.Item>
              <S.Item>
                {t('page--privacy-policy.consentByAuthorizedThirdParty')}
              </S.Item>
            </S.List>
            <Typography marginBottom="none">
              {t('page--privacy-policy.symptomCheckerConsent')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.dataSubjectRights')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataSubjectRightsExercise')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataConfirmationRequest')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataAccessRights')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataRectificationAndDeletion')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataProcessingLimitation')}
            </Typography>
            <Typography>{t('page--privacy-policy.dataPortability')}</Typography>
            <Typography>
              {t('page--privacy-policy.dataProcessingOpposition')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.consentWithdrawal')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.dataDeletionRights')}
            </Typography>
            <Typography>
              {t('page--privacy-policy.complaintToSupervisoryAuthority')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.dataProcessingOppositionArticle21')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.consentAndWithdrawal')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.consentWithdrawalMethod')}{' '}
              <a href="mailto:lami.pec@legalmail.it">
                {t('page--privacy-policy.lamiLegalMail')}
              </a>{' '}
              {t('page--privacy-policy.consentWithdrawalNonNegotiable')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.complaintToControlAuthority')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.rightToComplainArticle77')}
            </Typography>
            <Typography
              variant="heading_2"
              color="text__highlight"
              as="h2"
              marginTop="xlarge"
            >
              {t('page--privacy-policy.automatedDecisionMakingProcesses')}
            </Typography>
            <Typography marginBottom="none">
              {t('page--privacy-policy.noAutomatedDecisionMaking')}
            </Typography>
          </Grid.Wrapper>
        </S.Wrapper>
      </SectionWrapper>
    </>
  );
};

export default PrivacyPolicy;
